import styled from "styled-components";

export const Alert = styled.div`
  position: fixed;
  top: 0;
  right: 0;

  width: 0px;
  height: 60px;
  margin: 10px;

  z-index: 19;

  transition: width 0.4s;

  border-radius: 3px;
  background-color: ${(props) =>
    props.tipo === "sucesso" ? "var(--alertSucesso)" : "var(--alertErro)"};

  overflow: hidden;

  color: var(--white);

  > h1 {
    font-size: 18px;
    font-weight: 500;
    margin: 5px;

    white-space: nowrap;
  }

  > p {
    font-size: 14px;
    margin-left: 5px;
    white-space: nowrap;
  }

  > span {
    position: absolute;
    top: 0;
    right: 0;

    margin: 0px 5px;

    cursor: pointer;
    font-size: 20px;

    color: var(--white);

    :hover {
      color: var(--black);
    }
  }
`;
